(function (window) {
  'use strict';
  const skuContainer = document.querySelector('.review__container[data-review-sku]');
  const lang = document.documentElement.getAttribute('lang') || 'en-US';
  const locale = lang.replace('-', '_');
  if (skuContainer) {
    const sku = skuContainer.getAttribute('data-review-sku');
    window.turnToConfig = {
      locale: locale,
      pageId: 'pdp-page',
      sku: sku,
    };
    window.TurnToCmd = window.TurnToCmd || function () {
      (TurnToCmd.q = TurnToCmd.q || []).push(arguments)
    };
  }
})(this);
